import { Box } from "@material-ui/core";
import Breadcrumbs from "components/Breadcrumbs";
import DownloadRow from "components/DownloadRow";
import EmptyView from "components/EmptyView";
import Text from "components/Text";
import { pagePadding } from "data/commonClasses";
import { getTranslationContent } from "functions";
import { isEmpty } from "lodash";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

const PDFList = ({ pageData, lang, title, desc, breadcrumb, title1 }) => {
  const { t } = useTranslation();
  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t(breadcrumb), href: "" },
  ];
  return pageData && !isEmpty(pageData) ? (
    <div className={twMerge(pagePadding, "min-h-screen")}>
      <div className="w-full flex flex-col">
        <Breadcrumbs items={breadcrumbs} />
        <Text
          className="mt-5"
          text={`${t(title)} ${title1 ? " - " + t(title1) : ""}`}
          bold
          sectionTitle
        />
        {desc && desc !== "" ? (
          <Text className="pt-3 pb-6" text={t(desc)} />
        ) : (
          <div className="h-6" />
        )}
        {(pageData || [])?.map((oneData) => (
          <DownloadRow
            href={oneData?.pdf}
            key={oneData?._id}
            title={
              getTranslationContent(oneData, "title", lang) ||
              oneData?.title ||
              ""
            }
          />
        ))}
      </div>
    </div>
  ) : (
    <EmptyView text={t("noInfo")} icon={"fluent-mdl2:remove-content"} />
  );
};

export default PDFList;
